import React from 'react'

import { Heading } from '../../components/typography'

interface Props {
  label: string
}

export default function WidgetHeader({ label }: Props) {
  return (
    <Heading level={4} className="text-muted">
      {label}
    </Heading>
  )
}
